export function matches(query, module, keys) {
    return keys.every(key => module == null || query[key] == module[key] || module[key] == undefined || module[key] == '');
}
export function inputModule(midiInput) {
    return {
        id: midiInput.id,
        manufacturer: midiInput.manufacturer,
        name: midiInput.name,
        version: midiInput.version
    };
}
//# sourceMappingURL=InputModule.js.map